import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://tmqzheoukjiteejxkiat.supabase.co';
const SUPABASE_ANON_KEY = 'sb_publishable_lNDk48xgcyfcx_6X6km3xQ_uCDDW08g';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    flowType: 'pkce',
    detectSessionInUrl: true,
    persistSession: true,
  }
});